import { useParams } from "react-router-dom";
import {DiaEditorCreateRedirectFunction, useDiaEditor} from "../../components/DiaEditor";
import React, {ReactElement, useCallback, useEffect } from "react";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import * as yup from "yup";
import {UserForm} from "./Form";
import {
    CreateUserMutationMutation,
    GetUserQueryQueryResult,  UpdateUserMutationMutation,  UpdateUserMutationMutationResult,
    useCreateUserMutationMutation,
    useGetUserQueryQuery, User,
    useUpdateUserMutationMutation
} from "../../generated/graphql";
import { MutationResult } from "@apollo/client/react";


//const isoDateReg = /\d{4}-[01]\d-[0-3]\d/;
const validationSchema = yup.object().shape({
    name: yup.string().min(3),
    email: yup.string().email().required(),
    password: yup.string().test(
        'password',
        'password must be at least 8 characters',
        password => !password || password.length >= 8,
    )
});

const relationships = {
    role:'connect',
    salesTeams:'connect',
    proxyUser:'connect'
};

function makeBlankValues():User {
    return {
        name: '',
        email: '',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        password: '',
        role: {id: "1", name: 'User Role'},
        salesTeams: [],
        proxyUser:null
    }
}

export function UserEditor(): ReactElement {
    const params = useParams();
    const isNew = (params.id=='new');
    const query = useGetUserQueryQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateUserMutationMutation();
    const [createMutation,createResult] = useCreateUserMutationMutation();
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[saveMutation]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[createMutation]);
    const getValue = useCallback((result:GetUserQueryQueryResult)=>{
        return result.data?.user;
    },[]);
    const getSaveValue = useCallback((result:UpdateUserMutationMutationResult)=>{
        return result?.data?.updateUser;
    },[]);
    const getCreateRedirect = useCallback<DiaEditorCreateRedirectFunction<MutationResult<CreateUserMutationMutation>>>(({data,baseUrl})=>{
        return baseUrl+(data.data?.createUser?.id);
    },[]);
    const data = useDiaEditor<User,GetUserQueryQueryResult,CreateUserMutationMutation,UpdateUserMutationMutation>({save,saveResult,create,createResult,query:query,
        relationships:relationships,
        baseUrl:'/settings/users/',
        blankValues:makeBlankValues,
        label:'user',
        permission:'user',
        validationSchema:validationSchema,
        getValue:getValue,
        getSaveValue:getSaveValue,
        getCreateRedirect:getCreateRedirect
    });
    useEffect(()=>{
        if(data.waiting) return;
        if(data.form?.status!='ready') return;
        console.log('change password',data?.form?.status,data.waiting,data.form.values.password);
        data.form.setValue('password','');
    },[data.waiting]);
    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.loading) {
        return <WaitSpinner variant="panel"/>;
    }
    return <>
        {data.confirmation}
        <UserForm diaForm={data.form} readOnly={false}/>
    </>;
}